export enum SchedulePeriod {
  Weekly,
  Monthly,
  Annually,
}

export enum StorageItems {
  DisplayDate = 'displayDate',
}
